import isIframe from "@/lib/is-platform/is-iframe"
import { PREVIEW_QUERY_PARAM } from "@/lib/constants"

export default () =>
  isIframe() && window.location.search.includes(PREVIEW_QUERY_PARAM)
